import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Clock, LogOut, RefreshCw } from 'lucide-react';

interface SessionTimeoutWarningProps {
  isOpen: boolean;
  remainingTime: number;
  formatRemainingTime: () => string;
  onExtendSession: () => void;
  onLogout: () => void;
}

export const SessionTimeoutWarning: React.FC<SessionTimeoutWarningProps> = ({
  isOpen,
  remainingTime,
  formatRemainingTime,
  onExtendSession,
  onLogout
}) => {
  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-orange-100">
              <Clock className="h-6 w-6 text-orange-600" />
            </div>
            <div>
              <AlertDialogTitle className="text-lg font-semibold text-gray-900">
                Sessão Expirando
              </AlertDialogTitle>
            </div>
          </div>
          
          <AlertDialogDescription className="text-gray-600">
            Sua sessão será encerrada automaticamente por inatividade.
          </AlertDialogDescription>
          
          <div className="space-y-3 mt-4">
            <div className="flex items-center justify-center p-4 bg-orange-50 rounded-lg border border-orange-200">
              <div className="text-center">
                <div className="text-2xl font-bold text-orange-700 font-mono">
                  {formatRemainingTime()}
                </div>
                <div className="text-sm text-orange-600 mt-1">
                  Tempo restante
                </div>
              </div>
            </div>
            
            <p className="text-sm text-gray-600">
              Clique em <strong>"Continuar Sessão"</strong> para permanecer conectado ou 
              <strong> "Sair Agora"</strong> para fazer logout imediatamente.
            </p>
          </div>
        </AlertDialogHeader>
        
        <AlertDialogFooter className="flex gap-3 sm:gap-3">
          <AlertDialogCancel asChild>
            <Button 
              variant="outline" 
              onClick={onLogout}
              className="flex items-center gap-2 hover:bg-red-50 hover:border-red-300 hover:text-red-700"
            >
              <LogOut className="h-4 w-4" />
              Sair Agora
            </Button>
          </AlertDialogCancel>
          
          <AlertDialogAction asChild>
            <Button 
              onClick={onExtendSession}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700"
            >
              <RefreshCw className="h-4 w-4" />
              Continuar Sessão
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
